import { type QueryHookOptions, useQuery } from "@apollo/client";
import { BillingSellerQuery } from "../graphql/queries";
import type {
  BillingSellerQueryType,
  BillingSellerQueryVariablesType,
} from "@/types/graphql/admin.generated";

export const useBillingSellerQuery = (
  options?: QueryHookOptions<
    BillingSellerQueryType,
    BillingSellerQueryVariablesType
  >
) => {
  return useQuery<BillingSellerQueryType, BillingSellerQueryVariablesType>(
    BillingSellerQuery,
    options
  );
};
